module.exports = __webpack_public_path__ + "static/media/Users2.8db431ac.svg";